var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKajabi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: 45,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 { fill: url(#gradient3); }\n      .st1 { fill: url(#gradient4); }\n      .st2 { fill: url(#gradient5); }\n      .st3 { fill: url(#gradient2); }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient5",
    x1: 8.53,
    y1: 19.33,
    x2: 12.89,
    y2: 32.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff98b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff3e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f0182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient2",
    x1: 19.78,
    y1: 26.24,
    x2: 0.41,
    y2: 34.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f0182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff3e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff98b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient3",
    x1: 16.46,
    y1: 22.96,
    x2: 20.57,
    y2: 35.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff98b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff3e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f0182"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient4",
    x1: 20.3,
    y1: 28.51,
    x2: 20.3,
    y2: 36.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff98b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ff3e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f0182"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,30) scale(0.25) translate(-210,-310)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.5,357.3h-41.3c-2.6,0-4.3-2.5-3.4-4.9l45.2-134h41.8l-45.4,133.9c-.9,2.6.4,4.9,3.3,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.3,357.3h41.1c3.2,0,6.2-1.4,8.3-3.8l83.1-96.6h-33.3c-2.5,0-4.9,1-6.6,2.8l-91.7,96.5c-.9.9-1.7.9-2.6.7.8.4,1.3.4,1.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,256.9h40.3c6.1,0,6.9,5.8,3.5,9.6-8.2,9-15.1,16.3-23,30.8-10.1,18.7-11.2,62.6,26.8,56.9-7.6,2.5-15.7,3-20.6,3h-20.7c-1.6,0-7.4-.5-10.4-1.4-31-9.7-14.9-65.4,5.2-89.3,4-4.8,2.3-9.2-.9-9.6-.2,0,0,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.1,325.2h38.6c-3,15.5-14.7,32.2-46.8,32.2h-20c-3,0-8.4-.7-10.7-1.4,33-1.1,37-20.8,38.9-30.7h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKajabi);
export default __webpack_public_path__ + "static/media/kajabi.8887ffd4fbd0142420d8608b65d28642.svg";
export { ForwardRef as ReactComponent };